// @ts-ignore
import styles from './DENTModalOverviewSurfaces.module.scss';
import { SurfaceInterface } from '../../Interfaces/Surface.interface';
import { ToothSurface, ToothType } from '../../../../graphql/graphql';
import { useMemo } from 'react';
import { useDENTContext } from '../../Services/DENTContext';
import { TOOTH_SURFACES_TITLE_MAP } from '../../Helpers/surfaces/toothSurfacesTitleMap';

type Surface = Exclude<
	ToothSurface,
	ToothSurface.BuccalRestoration | ToothSurface.Crown
>;

const SURFACES_ROWS: Record<Surface, SurfaceInterface> = {
	[ToothSurface.CervicalBuccal]: {
		type: ToothSurface.CervicalBuccal,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.CervicalBuccal],
		className: styles.itemBig,
		closes: [ToothSurface.CervicalBuccal],
		opens: [ToothSurface.CervicalBuccal],
	},
	[ToothSurface.Buccal]: {
		type: ToothSurface.Buccal,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.Buccal],
		className: styles.itemSmall,
		closes: [ToothSurface.Buccal, ToothSurface.BuccalSurface],
		opens: [ToothSurface.Buccal],
	},
	[ToothSurface.Mesial]: {
		type: ToothSurface.Mesial,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.Mesial],
		className: styles.itemSmall,
		closes: [ToothSurface.Mesial, ToothSurface.Class_4Distal],
		opens: [ToothSurface.Mesial],
	},
	[ToothSurface.Incisal]: {
		type: ToothSurface.Incisal,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.Incisal],
		className: styles.itemSmall,
		closes: [ToothSurface.Incisal],
		opens: [ToothSurface.Incisal],
	},
	[ToothSurface.Occlusal]: {
		type: ToothSurface.Occlusal,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.Occlusal],
		className: styles.itemSmall,
		closes: [ToothSurface.Occlusal],
		opens: [ToothSurface.Occlusal],
	},
	[ToothSurface.Distal]: {
		type: ToothSurface.Distal,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.Distal],
		className: styles.itemSmall,
		closes: [ToothSurface.Distal, ToothSurface.Class_4Distal],
		opens: [ToothSurface.Distal],
	},
	[ToothSurface.Palatal]: {
		type: ToothSurface.Palatal,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.Palatal],
		className: styles.itemSmall,
		closes: [ToothSurface.Palatal, ToothSurface.PalatalSurface],
		opens: [ToothSurface.Palatal],
	},
	[ToothSurface.CervicalPalatal]: {
		type: ToothSurface.CervicalPalatal,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.CervicalPalatal],
		className: styles.itemBig,
		closes: [ToothSurface.CervicalPalatal],
		opens: [ToothSurface.CervicalPalatal],
	},
	[ToothSurface.MesioBuccalCusp]: {
		type: ToothSurface.MesioBuccalCusp,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.MesioBuccalCusp],
		className: styles.itemMedium,
		closes: [ToothSurface.MesioBuccalCusp],
		opens: [ToothSurface.MesioBuccalCusp],
	},
	[ToothSurface.DistoBuccalCusp]: {
		type: ToothSurface.DistoBuccalCusp,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.DistoBuccalCusp],
		className: styles.itemMedium,
		closes: [ToothSurface.DistoBuccalCusp],
		opens: [ToothSurface.DistoBuccalCusp],
	},
	[ToothSurface.MesioPalatalCusp]: {
		type: ToothSurface.MesioPalatalCusp,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.MesioPalatalCusp],
		className: styles.itemMedium,
		closes: [ToothSurface.MesioPalatalCusp],
		opens: [ToothSurface.MesioPalatalCusp],
	},
	[ToothSurface.DistoPalatalCusp]: {
		type: ToothSurface.DistoPalatalCusp,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.DistoPalatalCusp],
		className: styles.itemMedium,
		closes: [ToothSurface.DistoPalatalCusp],
		opens: [ToothSurface.DistoPalatalCusp],
	},
	[ToothSurface.MesioLingualCusp]: {
		type: ToothSurface.MesioLingualCusp,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.MesioLingualCusp],
		className: styles.itemMedium,
		closes: [ToothSurface.MesioLingualCusp],
		opens: [ToothSurface.MesioLingualCusp],
	},
	[ToothSurface.DistoLingualCusp]: {
		type: ToothSurface.DistoLingualCusp,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.DistoLingualCusp],
		className: styles.itemMedium,
		closes: [ToothSurface.DistoLingualCusp],
		opens: [ToothSurface.DistoLingualCusp],
	},
	[ToothSurface.PalatalSurface]: {
		type: ToothSurface.PalatalSurface,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.PalatalSurface],
		className: styles.itemMedium,
		opens: [ToothSurface.PalatalSurface, ToothSurface.Palatal],
		closes: [ToothSurface.PalatalSurface],
	},
	[ToothSurface.BuccalSurface]: {
		type: ToothSurface.BuccalSurface,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.BuccalSurface],
		className: styles.itemMedium,
		opens: [ToothSurface.BuccalSurface, ToothSurface.Buccal],
		closes: [ToothSurface.BuccalSurface],
	},
	[ToothSurface.LingualSurface]: {
		type: ToothSurface.LingualSurface,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.LingualSurface],
		className: styles.itemMedium,
		opens: [ToothSurface.LingualSurface, ToothSurface.Lingual],
		closes: [ToothSurface.LingualSurface],
	},
	[ToothSurface.Class_4Mesial]: {
		type: ToothSurface.Class_4Mesial,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.Class_4Mesial],
		className: styles.itemMedium,
		opens: [ToothSurface.Class_4Mesial, ToothSurface.Mesial],
		closes: [ToothSurface.Class_4Mesial],
	},
	[ToothSurface.Class_4Distal]: {
		type: ToothSurface.Class_4Distal,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.Class_4Distal],
		className: styles.itemMedium,
		opens: [ToothSurface.Class_4Distal, ToothSurface.Distal],
		closes: [ToothSurface.Class_4Distal],
	},
	[ToothSurface.Lingual]: {
		type: ToothSurface.Lingual,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.Lingual],
		className: styles.itemSmall,
		closes: [ToothSurface.Lingual],
		opens: [ToothSurface.Lingual],
	},
	[ToothSurface.CervicalLingual]: {
		type: ToothSurface.CervicalLingual,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.CervicalLingual],
		className: styles.itemBig,
		closes: [ToothSurface.CervicalLingual],
		opens: [ToothSurface.CervicalLingual],
	},
	[ToothSurface.BuccalCusp]: {
		type: ToothSurface.BuccalCusp,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.BuccalCusp],
		className: styles.itemMedium,
		closes: [ToothSurface.BuccalCusp],
		opens: [ToothSurface.BuccalCusp],
	},
	[ToothSurface.PalatalCusp]: {
		type: ToothSurface.PalatalCusp,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.PalatalCusp],
		className: styles.itemMedium,
		closes: [ToothSurface.PalatalCusp],
		opens: [ToothSurface.PalatalCusp],
	},
	[ToothSurface.LingualCusp]: {
		type: ToothSurface.LingualCusp,
		title: TOOTH_SURFACES_TITLE_MAP[ToothSurface.LingualCusp],
		className: styles.itemMedium,
		closes: [ToothSurface.LingualCusp],
		opens: [ToothSurface.LingualCusp],
	},
};

export default function useSurfacesRows() {
	const { activeTooth } = useDENTContext();

	if (!activeTooth) {
		return { rows: [] };
	}

	const isUpper = useMemo(() => {
		return (
			(activeTooth.number >= 11 && activeTooth.number <= 28) ||
			(activeTooth.number >= 51 && activeTooth.number <= 65)
		);
	}, [activeTooth]);

	const ROW_3 = useMemo(() => {
		switch (activeTooth.type) {
			case ToothType.Molar:
			case ToothType.Premolar:
				return [
					SURFACES_ROWS[ToothSurface.Mesial],
					SURFACES_ROWS[ToothSurface.Occlusal],
					SURFACES_ROWS[ToothSurface.Distal],
				];
			case ToothType.Incisor:
			case ToothType.Canine:
			default:
				return [
					SURFACES_ROWS[ToothSurface.Mesial],
					SURFACES_ROWS[ToothSurface.Incisal],
					SURFACES_ROWS[ToothSurface.Distal],
				];
		}
	}, [activeTooth]);

	const ROW_4 = useMemo(() => {
		if (isUpper) {
			return [SURFACES_ROWS[ToothSurface.Palatal]];
		}
		return [SURFACES_ROWS[ToothSurface.Lingual]];
	}, [isUpper]);

	const ROW_5 = useMemo(() => {
		if (isUpper) {
			return [SURFACES_ROWS[ToothSurface.CervicalPalatal]];
		}
		return [SURFACES_ROWS[ToothSurface.CervicalLingual]];
	}, [isUpper]);

	const ROW_6 = useMemo(() => {
		switch (activeTooth.type) {
			case ToothType.Molar:
				return [
					SURFACES_ROWS[ToothSurface.MesioBuccalCusp],
					SURFACES_ROWS[ToothSurface.DistoBuccalCusp],
				];
			case ToothType.Premolar:
				if (isUpper) {
					return [
						SURFACES_ROWS[ToothSurface.BuccalCusp],
						SURFACES_ROWS[ToothSurface.PalatalCusp],
					];
				}
				return [
					SURFACES_ROWS[ToothSurface.BuccalCusp],
					SURFACES_ROWS[ToothSurface.LingualCusp],
				];
			case ToothType.Incisor:
			case ToothType.Canine:
			default:
				return [
					SURFACES_ROWS[ToothSurface.Class_4Mesial],
					SURFACES_ROWS[ToothSurface.Class_4Distal],
				];
		}
	}, [activeTooth]);

	const ROW_7 = useMemo(() => {
		switch (activeTooth.type) {
			case ToothType.Molar:
				if (isUpper) {
					return [
						SURFACES_ROWS[ToothSurface.MesioPalatalCusp],
						SURFACES_ROWS[ToothSurface.DistoPalatalCusp],
					];
				}
				return [
					SURFACES_ROWS[ToothSurface.MesioLingualCusp],
					SURFACES_ROWS[ToothSurface.DistoLingualCusp],
				];
			case ToothType.Premolar:
			case ToothType.Incisor:
			case ToothType.Canine:
			default:
				if (isUpper) {
					return [
						SURFACES_ROWS[ToothSurface.BuccalSurface],
						SURFACES_ROWS[ToothSurface.PalatalSurface],
					];
				}
				return [
					SURFACES_ROWS[ToothSurface.BuccalSurface],
					SURFACES_ROWS[ToothSurface.LingualSurface],
				];
		}
	}, [activeTooth, isUpper]);

	return {
		rows: [
			[SURFACES_ROWS[ToothSurface.CervicalBuccal]],
			[SURFACES_ROWS[ToothSurface.Buccal]],
			ROW_3,
			ROW_4,
			ROW_5,
			ROW_6,
			ROW_7,
		],
	};
}
